import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col } from 'react-bootstrap';
import Personal from './components/Personal';
import { useSelector } from 'react-redux';
import { RootState } from './store';
import PdfIframePreview from './components/PdfIframePreview';
import EntryFormSelector from './components/ExperienceSelector';
import Header from './components/Header';
import Styling from './components/Styling';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Error from './components/Error';
import Success from './components/DownloadPdf';

function Home() {
  const theme = useSelector((state: RootState) => state.themeSlice);
  return  <div>
  < Header/>
  <Container fluid className="p-4">
    <Row>
      <Col md={5}>
        <Personal />
        <EntryFormSelector />
        <Styling primaryColor={theme.primaryColor} secondaryColor={theme.secondaryColor} fontColor={theme.fontColor}/>
      </Col>
      <Col md={7} style={{minHeight: '100%'}}>
        <PdfIframePreview primaryColor={theme.primaryColor} secondaryColor={theme.secondaryColor} fontColor={theme.fontColor}/>
      </Col>
    </Row>
  </Container>
</div>
}
function App() {
  return (
    <Router>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/success" element={<Success />} />
      <Route path="/cancel" element={<Error />} />
    </Routes>
  </Router>
  );
}

export default App;
